import { DeviceManifest } from '@rapoo/device-sdk'
import { mouseMacro, mousePerfCap, retailMouseConfig } from './generate/capabilityPresets'

/**
 * VT1 SE 设备清单
 **/
const rapooVT1SE: DeviceManifest = {
  channel: ['global'],
  model: 'VT1 SE',
  mainControl: 'VT1 SE',
  dongleModel: 'Dongle_CH591',
  type: 'mouse',
  version: '1.0.0',
  hardware: {
    vendorId: 0x24ae,
    productId: [0x4a11, 0x1a11],
    currentPid: 0x4a11,
    transport: 'HID',
    filters: [
      {
        usagePage: 65280,
        usage: 15,
        description: 'Configuration Interface (Secondary)',
        type: 'default',
      },
      {
        usagePage: 65392,
        usage: 113,
        description: 'Only update Firmware',
        type: 'update',
      },
    ],
  },
  driver: 'VT_CH584',
  MCU: 'CH584',
  sensor: 'PAW3311',
  microSwitch: 'mechanical',
  encoder: 'mechanical',
  battery: 300,
  ui: {
    assetsDir: 'manifests/VT1 SE',
    // 颜色配置
    colors: {
      series: [
        {
          name: 'common.products.VT1_SE.Black',
          value: '#2B2B2B',
          key: 'Black',
        },
      ],
      current: 'Black',
    },
    // 小图
    icon: 'Hardware-Wireframe-Mouse',
    // 是否支持设备概览
    overview: true,
  },
  capabilities: [
    retailMouseConfig,
    {
      type: 'dpi',
      config: {
        min: 50,
        max: 12000,
        step: [
          { from: 50, to: 10000, step: 50 },
          { from: 10050, to: 12000, step: 100 },
        ],
      },
    },
    mouseMacro,
    mousePerfCap({ tier: 'paw3311' }),
  ],
  layout: {
    keys: [
      [
        {
          key: 0,
          keywords: '左击',
          x: -25,
          y: 50,
          alignLeft: false,
          url: 'mouse left',
        },
        {
          key: 1,
          keywords: '中键',
          x: 240,
          y: 52,
          alignLeft: true,
          url: 'roller middle',
        },
        {
          key: 2,
          keywords: '右击',
          x: 240,
          y: 156,
          alignLeft: true,
          url: 'mouse right',
        },
        {
          key: 5,
          keywords: '右侧',
          x: -25,
          y: 132,
          alignLeft: false,
          url: 'mouse forward',
        },
        {
          key: 6,
          keywords: '左侧',
          x: -25,
          y: 195,
          alignLeft: false,
          url: 'mouse back',
        },
        {
          key: 9,
          keywords: '上滚',
          x: 240,
          y: 0,
          alignLeft: true,
          url: 'roller up',
        },
        {
          key: 10,
          keywords: '下滚',
          x: 240,
          y: 104,
          alignLeft: true,
          url: 'roller down',
        },
        {
          key: 13,
          keywords: 'DIY',
          x: 655,
          y: 118,
          alignLeft: true,
          url: 'diy',
        },
      ],
    ],
  },
}

export default rapooVT1SE
